module.exports = __webpack_public_path__ + "img/Expo_TopicA6.1096f64b.png";